import { CbridgePalette } from './theme.constant';

/** UI brand: cBridge by default, cAntifraud for a standalone-Markout tenant (LB-5777) */
export enum Brand {
  CBridge = 'cbridge',
  CAntifraud = 'cantifraud',
}

export interface IBrandPalette {
  /** Tabs indicator, `palette.secondary.main`, the Markout "charted" bar */
  accent: string;
  /** Logo colour (the Markout preloader arc) */
  logo: string;
  button: {
    main: string;
    /** Darker shade: hover of a selected toggle */
    active: string;
    /** Final hover colour of a contained primary button */
    hover: string;
    disabled: string;
  };
  switch: {
    track: string;
    disabledTrack: string;
  };
}

const { button, switch: switchStates, hoverOverlay } = CbridgePalette;

export const BRAND_PALETTE: Record<Brand, IBrandPalette> = {
  [Brand.CBridge]: {
    accent: CbridgePalette.accent,
    logo: '#773DE7',
    button: {
      main: button.primary.main,
      active: button.primary.active,
      hover: `color-mix(in srgb, ${button.primary.active}, ${hoverOverlay})`,
      disabled: button.primary.disabled,
    },
    switch: {
      track: switchStates.on.main.track,
      disabledTrack: switchStates.on.disabled.track,
    },
  },
  // Figma: button #228D65, hover = #228D65 + 10% black; the rest is derived from the cBridge ratios
  [Brand.CAntifraud]: {
    accent: '#228D65',
    logo: '#16DB93',
    button: {
      main: '#228D65',
      active: '#1F7F5B',
      hover: '#1F7F5B',
      disabled: '#228D6533',
    },
    switch: {
      track: '#228D65',
      disabledTrack: '#1B5241',
    },
  },
};

declare module '@mui/material/styles' {
  interface Palette {
    brand: IBrandPalette;
  }

  interface PaletteOptions {
    brand?: IBrandPalette;
  }
}
